import MobileTicket from './Ticket';
export default MobileTicket;